import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/carboncopy/sites/tippyjs/website/src/components/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`There are two ways to install the package.`}</p>
    <h3>{`1. Package Manager`}</h3>
    <pre {...{
      "className": "grvsc-container moonlight-ii",
      "data-language": "bash",
      "data-index": "0"
    }}><code parentName="pre" {...{
        "className": "grvsc-code"
      }}><span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "mtk3"
          }}>{`# npm`}</span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "mtk1"
          }}>{`npm i tippy.js`}</span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "mtk3"
          }}>{`# Yarn`}</span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "mtk1"
          }}>{`yarn add tippy.js`}</span></span></code></pre>
    <p>{`In your application, import the `}<inlineCode parentName="p">{`tippy`}</inlineCode>{` module, and the core CSS:`}</p>
    <pre {...{
      "className": "grvsc-container moonlight-ii",
      "data-language": "js",
      "data-index": "1"
    }}><code parentName="pre" {...{
        "className": "grvsc-code"
      }}><span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "mtk5"
          }}>{`import`}</span><span parentName="span" {...{
            "className": "mtk1"
          }}>{` tippy `}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`from`}</span><span parentName="span" {...{
            "className": "mtk1"
          }}>{` `}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`'`}</span><span parentName="span" {...{
            "className": "mtk11"
          }}>{`tippy.js`}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`';`}</span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "mtk5"
          }}>{`import`}</span><span parentName="span" {...{
            "className": "mtk1"
          }}>{` `}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`'`}</span><span parentName="span" {...{
            "className": "mtk11"
          }}>{`tippy.js/dist/tippy.css`}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`';`}</span></span></code></pre>
    <p>{`This assumes you're using a module bundler like webpack, Rollup, or Parcel. If
you're getting an error message about `}<inlineCode parentName="p">{`process`}</inlineCode>{` inside the browser,
`}<a parentName="p" {...{
        "href": "../faq/#im-getting-uncaught-referenceerror-process-is-not-defined"
      }}>{`see the FAQ for help.`}</a></p>
    <h3>{`2. CDN`}</h3>
    <pre {...{
      "className": "grvsc-container moonlight-ii",
      "data-language": "html",
      "data-index": "2"
    }}><code parentName="pre" {...{
        "className": "grvsc-code"
      }}><span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "mtk5"
          }}>{`<`}</span><span parentName="span" {...{
            "className": "mtk14"
          }}>{`script `}</span><span parentName="span" {...{
            "className": "mtk8"
          }}>{`src`}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`="`}</span><span parentName="span" {...{
            "className": "mtk11"
          }}>{`https://unpkg.com/popper.js@1`}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`"></`}</span><span parentName="span" {...{
            "className": "mtk14"
          }}>{`script`}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`>`}</span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "mtk5"
          }}>{`<`}</span><span parentName="span" {...{
            "className": "mtk14"
          }}>{`script `}</span><span parentName="span" {...{
            "className": "mtk8"
          }}>{`src`}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`="`}</span><span parentName="span" {...{
            "className": "mtk11"
          }}>{`https://unpkg.com/tippy.js@5`}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`"></`}</span><span parentName="span" {...{
            "className": "mtk14"
          }}>{`script`}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`>`}</span></span></code></pre>
    <p>{`Place them at the very bottom of the `}<inlineCode parentName="p">{`<body>`}</inlineCode>{`, ensuring they are placed before
your own scripts. The version numbers after `}<inlineCode parentName="p">{`@`}</inlineCode>{` are important, make sure they
don't get removed.`}</p>
    <h4>{`Development version`}</h4>
    <p>{`While developing, it's recommended to use the development file which includes
helpful warnings and error messages when something goes wrong:`}</p>
    <pre {...{
      "className": "grvsc-container moonlight-ii",
      "data-language": "html",
      "data-index": "3"
    }}><code parentName="pre" {...{
        "className": "grvsc-code"
      }}><span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "mtk5"
          }}>{`<`}</span><span parentName="span" {...{
            "className": "mtk14"
          }}>{`script `}</span><span parentName="span" {...{
            "className": "mtk8"
          }}>{`src`}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`="`}</span><span parentName="span" {...{
            "className": "mtk11"
          }}>{`https://unpkg.com/popper.js@1`}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`"></`}</span><span parentName="span" {...{
            "className": "mtk14"
          }}>{`script`}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`>`}</span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "mtk5"
          }}>{`<`}</span><span parentName="span" {...{
            "className": "mtk14"
          }}>{`script `}</span><span parentName="span" {...{
            "className": "mtk8"
          }}>{`src`}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`="`}</span><span parentName="span" {...{
            "className": "mtk11"
          }}>{`https://unpkg.com/tippy.js@5/dist/tippy-bundle.iife.js`}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`"></`}</span><span parentName="span" {...{
            "className": "mtk14"
          }}>{`script`}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`>`}</span></span></code></pre>
    <p>{`When you're finished developing (or deploying for production), you can remove
everything after `}<inlineCode parentName="p">{`@5`}</inlineCode>{` (the production file as listed before).`}</p>
    <h3>{`CSS`}</h3>
    <p>{`Tippy includes a CSS stylesheet by default for the base tooltip styling, fade
animation, CSS arrows, and other required CSS.`}</p>
    <h4>{`CDN`}</h4>
    <p>{`When including the script link above via CDN, the CSS stylesheet is injected
into its own `}<inlineCode parentName="p">{`<style>`}</inlineCode>{` tag in `}<inlineCode parentName="p">{`<head>`}</inlineCode>{`. If you have CSP enabled, you should use
`}<inlineCode parentName="p">{`dist/tippy.iife.js`}</inlineCode>{` and link the stylesheet `}<inlineCode parentName="p">{`dist/tippy.css`}</inlineCode>{` separately instead
of relying on injection.`}</p>
    <h4>{`Contents`}</h4>
    <p><a parentName="p" {...{
        "href": "https://unpkg.com/tippy.js@5/"
      }}>{`View the package contents on unpkg`}</a></p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`dist/tippy-bundle.js`}</inlineCode>{` = Core JS + Core CSS injected into `}<inlineCode parentName="li">{`<head>`}</inlineCode>{` (default
for CDN version)`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`dist/tippy.js`}</inlineCode>{` = Core JS (default for ESM/CJS versions)`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`dist/tippy.css`}</inlineCode>{` = Core CSS`}</li>
    </ul>
    <h3>{`Optional extra imports`}</h3>
    <p>{`For brevity, this documentation shows imports via a module bundler in Node. If
you're using the CDN, you'll be using `}<inlineCode parentName="p">{`<link>`}</inlineCode>{` tags instead.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note`}</strong></p>
      <p parentName="blockquote">{`This is not a required import — it's just a demonstration of how you will
import extra parts of the library depending on your choice when reading the
documentation.`}</p>
    </blockquote>
    <p>{`This optional extra import in the documentation:`}</p>
    <pre {...{
      "className": "grvsc-container moonlight-ii",
      "data-language": "js",
      "data-index": "4"
    }}><code parentName="pre" {...{
        "className": "grvsc-code"
      }}><span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "mtk5"
          }}>{`import`}</span><span parentName="span" {...{
            "className": "mtk1"
          }}>{` `}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`'`}</span><span parentName="span" {...{
            "className": "mtk11"
          }}>{`tippy.js/animations/scale.css`}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`';`}</span></span></code></pre>
    <p>{`Is equivalent to this using a CDN in the browser:`}</p>
    <pre {...{
      "className": "grvsc-container moonlight-ii",
      "data-language": "html",
      "data-index": "5"
    }}><code parentName="pre" {...{
        "className": "grvsc-code"
      }}><span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "mtk5"
          }}>{`<`}</span><span parentName="span" {...{
            "className": "mtk14"
          }}>{`link`}</span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "mtk14"
          }}>{`  `}</span><span parentName="span" {...{
            "className": "mtk8"
          }}>{`rel`}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`="`}</span><span parentName="span" {...{
            "className": "mtk11"
          }}>{`stylesheet`}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`"`}</span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "mtk14"
          }}>{`  `}</span><span parentName="span" {...{
            "className": "mtk8"
          }}>{`href`}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`="`}</span><span parentName="span" {...{
            "className": "mtk11"
          }}>{`https://unpkg.com/tippy.js@5/animations/scale.css`}</span><span parentName="span" {...{
            "className": "mtk5"
          }}>{`"`}</span></span>{`
`}<span parentName="code" {...{
          "className": "grvsc-line"
        }}><span parentName="span" {...{
            "className": "mtk5"
          }}>{`/>`}</span></span></code></pre>
    <h3>{`Component wrappers`}</h3>
    <ul>
      <li parentName="ul">{`React: `}<a parentName="li" {...{
          "href": "https://github.com/atomiks/tippy.js-react"
        }}>{`@tippy.js/react`}</a></li>
    </ul>
    <h3>{`JavaScript syntax`}</h3>
    <p>{`This documentation is making use of new JavaScript features (ES6+) that old
browsers like IE11 do not support. Although Tippy.js itself supports IE11, the
code written in these docs may need to be transpiled using a tool like Babel to
a compatible format if you want to copy and paste it.`}</p>

    <style {...{
      "className": "grvsc-styles"
    }}>{`
  .grvsc-container {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    padding-top: 1rem;
    padding-top: var(--grvsc-padding-top, var(--grvsc-padding-v, 1rem));
    padding-bottom: 1rem;
    padding-bottom: var(--grvsc-padding-bottom, var(--grvsc-padding-v, 1rem));
    border-radius: 8px;
    border-radius: var(--grvsc-border-radius, 8px);
    font-feature-settings: normal;
  }
  
  .grvsc-code {
    display: inline-block;
    min-width: 100%;
  }
  
  .grvsc-line {
    display: inline-block;
    box-sizing: border-box;
    width: 100%;
    padding-left: 1.5rem;
    padding-left: var(--grvsc-padding-left, var(--grvsc-padding-h, 1.5rem));
    padding-right: 1.5rem;
    padding-right: var(--grvsc-padding-right, var(--grvsc-padding-h, 1.5rem));
  }
  
  .grvsc-line-highlighted {
    background-color: var(--grvsc-line-highlighted-background-color, transparent);
    box-shadow: inset var(--grvsc-line-highlighted-border-width, 4px) 0 0 0 var(--grvsc-line-highlighted-border-color, transparent);
  }
  
  .moonlight-ii {
    background-color: #222436;
    color: #c8d3f5;
  }
  .moonlight-ii .mtk3 { color: #7A88CF; }
  .moonlight-ii .mtk1 { color: #C8D3F5; }
  .moonlight-ii .mtk5 { color: #86E1FC; }
  .moonlight-ii .mtk11 { color: #C3E88D; }
  .moonlight-ii .mtk14 { color: #FF757F; }
  .moonlight-ii .mtk8 { color: #C099FF; }
`}</style>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      